import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LteManageInventoryService {
  private baseUrl = '/api/LTE'; 
  constructor(private dataService: DataService) {}


 uploadInventory(formData: FormData) {
  return this.dataService.post('/api/LTE/postLTEInventory', formData);
}




getLTEInventory(productType: number, searchQuery?: string) {
  let url = `/api/LTE/getLTEInventory?productType=${productType}`;
  if (searchQuery) {
    url += `&searchQuery=${searchQuery}`;
  }
  return this.dataService.getRecord(url);
}


}
